import styled from "styled-components";

export const EmergencyOrdersContentLayout = styled.div`
    display: grid;
    grid-auto-flow: row;
    background-color: ${({ theme }) => theme.color.white};
    padding: 1.6rem;
    gap: 3.2rem;
`;
